"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodedResourceBundle = exports.CodedResource = void 0;
/**
 * Class representing any item that can be coded with a single unique string (for example report timezones in the DB)
 */
class CodedResource {
    constructor(code) {
        this.code = code;
    }
}
exports.CodedResource = CodedResource;
/**
 * Class representing a bundle of {@link CodedResource} items (for example, all supported timezones)
 */
class CodedResourceBundle {
    constructor(items, defaultValue) {
        this.items = items;
        this.defaultValue = defaultValue;
        // Init dictionary
        this.dict = {};
        for (let item of items) {
            let key = item.code;
            if (this.dict[key] != undefined) {
                throw new Error("Duplicate item with code '" + item.code + "' defined: " +
                    JSON.stringify(this.dict[key]) + " and " + JSON.stringify(item));
            }
            this.dict[key] = item;
        }
    }
    /**
     * Get an item by its code
     * @param code item's code
     * @returns matching item, or undefined if no match is found
     */
    get(code) {
        return this.dict[code];
    }
    /**
     * Get default item
     * @returns default item, or undefined if not set
     */
    getDefault() {
        return this.defaultValue;
    }
    /**
     * Get the matching item according to a value field
     * @param value desired value
     * @param valueGetter function that retrieves the value from the item
     * @returns first matching item (the item whose gotten value === <code>passed value</code>) or undefined
     */
    getByValue(value, valueGetter) {
        return this.items.find(item => valueGetter(item) === value);
    }
}
exports.CodedResourceBundle = CodedResourceBundle;
//# sourceMappingURL=codedResource.js.map